<section class="flex flex-col lg:flex-row lg:justify-between">
  <div class="mb-2 lg:mb-6">
    <h1 class="mb-2.5 text-base font-bold">Welcome</h1>
    @if (accountName) {
      <div
        class="mb-0 break-words font-montserrat text-4xl font-light italic leading-[1.2]"
      >
        {{ accountName }}
      </div>
    }
  </div>

  @if (
    billingAddress || lastInvoiceDate || (lastPaymentDate && lastPaymentAmount)
  ) {
    <div
      class="flex flex-col justify-center gap-2 py-2 font-montserrat text-sm lg:max-w-[385px] lg:border-l lg:border-white lg:pl-6"
    >
      @if (billingAddress) {
        <div>
          <span class="font-bold">Billing Address:</span>
          <span class="ml-2 uppercase">{{ billingAddress }}</span>
        </div>
      }

      @if (lastInvoiceDate) {
        <div>
          <span class="font-bold">Last Invoice Date:</span>
          <span class="ml-2 uppercase">{{
            lastInvoiceDate | date: 'MMM d, y'
          }}</span>
        </div>
      }

      @if (lastPaymentDate && lastPaymentAmount) {
        <div>
          <span class="font-bold">Last Payment:</span>
          <span class="ml-2 uppercase"
            >{{ lastPaymentAmount | currency }} on
            {{ lastPaymentDate | date: 'MMM d, y' }}</span
          >
        </div>
      }
    </div>
  }
</section>
